import { injectable } from 'inversify';
import { BehaviorSubject, takeUntil, Subject } from 'rxjs';
import { createSignal, onCleanup } from 'solid-js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let OverlayService = class {
  // #region Properties
  _overlayComponent = new BehaviorSubject(null);
  get overlayComponent() {
    return this._overlayComponent.asObservable();
  }
  get isOpen() {
    return this._overlayComponent.value !== null;
  }
  // #endregion
  // #region Public Methods
  show(request) {
    this._overlayComponent.next({
      component: request.component,
      props: request.props || {}
    });
  }
  handleBeforeLeave(e) {
    if (!this.isOpen) {
      return;
    }
    e.preventDefault();
    this.close();
  }
  close() {
    this._overlayComponent.next(null);
  }
  // #endregion
};
OverlayService = __decorateClass([
  injectable()
], OverlayService);

function createFromObservable(input, defaultValue, cleanup$ = onCleanup$()) {
  const [value, setValue] = createSignal(defaultValue);
  input.pipe(takeUntil(cleanup$)).subscribe(setValue);
  return [value, setValue];
}
function onCleanup$() {
  const obs = new Subject();
  onCleanup(() => {
    obs.next();
    obs.complete();
  });
  return obs.asObservable();
}

export { OverlayService, createFromObservable, onCleanup$ };
//# sourceMappingURL=index.es.js.map
